import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { CampaignsCreateForm } from '../../../../features/campaigns'
import { useCombos } from '../../../../features/combos/hooks'
import { CAMPAIGNS_COMBOS_IDS } from '../../constants'
import { PageDisplayer } from '../../../../ui'

export const CampaignsCreatePage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { formatMessage } = useIntl()
  useCombos(CAMPAIGNS_COMBOS_IDS)

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    navigate('/campaigns' + prevSearch)
  }

  return (
    <PageDisplayer
      maxWidth="md"
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.campaigns.detail.goBack' })}
    >
      <Box mb={2}>
        <Typography variant="h4" color="textSecondary">
          {formatMessage({ id: 'pages.campaigns.create.title' })}
        </Typography>
      </Box>
      <CampaignsCreateForm />
    </PageDisplayer>
  )
}
